<template>
  <v-dialog v-model="dialog" width="500" :persistent="persistent">
    <v-card>
      <v-card-title :class="headlineClass" primary-title>
        {{ title }}
      </v-card-title>
      <v-layout class="px-5 py-5">
        <v-row class="mx-2 my-2">
          <span :class="messageTextClass">{{ message }}</span>
          <slot></slot>
        </v-row>
      </v-layout>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  
          v-if="cancelButton"
          :buttonType="TEXT_BUTTON"
          outlined  
          class="mr-2" 
          color="error"
          @click="onCancel()"
        >
        {{ cancelButtonText }}
        </v-btn>
        <v-btn
          v-if="confirmButton"
          :buttonType="RAISED_BUTTON"
          color="primary"
          @click="onConfirmation()"
          :loading="confirmBtnLoading"
        >
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { TEXT_BUTTON, RAISED_BUTTON, OUTLINED_BUTTON } from "@/components/common/button/_buttontypes";


export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Confirmation",
    },
    message: {
      type: String,
      default: "Are you sure?",
    },
    confirmButtonText: {
      type: String,
      default: "Confirm",
    },
    cancelButtonText: {
      type: String,
      default: "Cancel",
    },
    cancelButton: {
      type: Boolean,
      default: true,
    },
    confirmButton: {
      type: Boolean,
      default: true,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    headlineClass: {
      type: String,
      default: "headline primary white--text",
    },
    confirmBtnLoading: {
      type: Boolean,
      default: false,
    },
    messageTextClass: {
      type: String,
      default: "",
      required: false,
    },
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      TEXT_BUTTON: TEXT_BUTTON,
      RAISED_BUTTON: RAISED_BUTTON,
      OUTLINED_BUTTON: OUTLINED_BUTTON,
    };
  },
  methods: {
    onConfirmation() {
      this.$emit("onConfirmation");
    },
    onCancel() {
      this.$emit("onCancel");
    },
  },

};
</script>

<style scoped>
  .text--red {
    color: red;
  }
</style>